import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import locale from '@/store/modules/locale'
import leads from '@/store/modules/leads'
import { LeadStatus } from '@/constants'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => {
    return {
      leads: {
        items: state.leads.items.map(lead => ({
          ...lead,
          // Never keep in progress status in local storage
          status: lead.status === LeadStatus.IN_PROGRESS ? LeadStatus.INTERRUPTED : lead.status,
          req: null
        }))
      }
    }
  }
})

export default new Vuex.Store({
  modules: {
    locale,
    leads
  },
  plugins: [vuexLocal.plugin]
})
